import { render, staticRenderFns } from "./ResizeContainer.vue?vue&type=template&id=65018bbe&scoped=true&"
import script from "./ResizeContainer.vue?vue&type=script&lang=js&"
export * from "./ResizeContainer.vue?vue&type=script&lang=js&"
import style0 from "./ResizeContainer.vue?vue&type=style&index=0&id=65018bbe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65018bbe",
  null
  
)

export default component.exports